"use strict";
/* Generated from:
 * ap-northeast-1 (https://d33vqc0rt9ld30.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-2 (https://d1ane3fvebulky.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-3 (https://d2zq80gdmjim8k.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-south-1 (https://d2senuesg1djtx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-1 (https://doigdx0kgq9el.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-2 (https://d2stg8d246z9di.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ca-central-1 (https://d2s8ygphhesbe7.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-central-1 (https://d1mta8qj7i28i2.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-1 (https://d3teyb21fexa9r.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-2 (https://d1742qcu2c1ncx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-3 (https://d2d0mfegowb3wk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * sa-east-1 (https://d3c9jyj3w509b0.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-1 (https://d1uauaxba7bl26.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-2 (https://dnwj8swjjbsbt.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-1 (https://d68hl49wbnanq.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-2 (https://d201a2mn26r7lk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = require("../resource");
class LogConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.LogConfiguration = LogConfiguration;
class FirelensConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.FirelensConfiguration = FirelensConfiguration;
class Device {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Device = Device;
class EFSVolumeConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.EFSVolumeConfiguration = EFSVolumeConfiguration;
class SystemControl {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SystemControl = SystemControl;
class EphemeralStorage {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.EphemeralStorage = EphemeralStorage;
class ResourceRequirement {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ResourceRequirement = ResourceRequirement;
class DockerVolumeConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DockerVolumeConfiguration = DockerVolumeConfiguration;
class AuthorizationConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AuthorizationConfig = AuthorizationConfig;
class MountPoint {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MountPoint = MountPoint;
class KernelCapabilities {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.KernelCapabilities = KernelCapabilities;
class PortMapping {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.PortMapping = PortMapping;
class Ulimit {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Ulimit = Ulimit;
class ContainerDependency {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ContainerDependency = ContainerDependency;
class HostVolumeProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HostVolumeProperties = HostVolumeProperties;
class RepositoryCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RepositoryCredentials = RepositoryCredentials;
class InferenceAccelerator {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InferenceAccelerator = InferenceAccelerator;
class Secret {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Secret = Secret;
class EnvironmentFile {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.EnvironmentFile = EnvironmentFile;
class VolumeFrom {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VolumeFrom = VolumeFrom;
class HostEntry {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HostEntry = HostEntry;
class TaskDefinitionPlacementConstraint {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TaskDefinitionPlacementConstraint = TaskDefinitionPlacementConstraint;
class Volume {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Volume = Volume;
class Tmpfs {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Tmpfs = Tmpfs;
class ContainerDefinition {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ContainerDefinition = ContainerDefinition;
class KeyValuePair {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.KeyValuePair = KeyValuePair;
class HealthCheck {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HealthCheck = HealthCheck;
class LinuxParameters {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.LinuxParameters = LinuxParameters;
class ProxyConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ProxyConfiguration = ProxyConfiguration;
class TaskDefinition extends resource_1.ResourceBase {
    constructor(properties) {
        super('AWS::ECS::TaskDefinition', properties || {});
    }
}
exports.default = TaskDefinition;
TaskDefinition.LogConfiguration = LogConfiguration;
TaskDefinition.FirelensConfiguration = FirelensConfiguration;
TaskDefinition.Device = Device;
TaskDefinition.EFSVolumeConfiguration = EFSVolumeConfiguration;
TaskDefinition.SystemControl = SystemControl;
TaskDefinition.EphemeralStorage = EphemeralStorage;
TaskDefinition.ResourceRequirement = ResourceRequirement;
TaskDefinition.DockerVolumeConfiguration = DockerVolumeConfiguration;
TaskDefinition.AuthorizationConfig = AuthorizationConfig;
TaskDefinition.MountPoint = MountPoint;
TaskDefinition.KernelCapabilities = KernelCapabilities;
TaskDefinition.PortMapping = PortMapping;
TaskDefinition.Ulimit = Ulimit;
TaskDefinition.ContainerDependency = ContainerDependency;
TaskDefinition.HostVolumeProperties = HostVolumeProperties;
TaskDefinition.RepositoryCredentials = RepositoryCredentials;
TaskDefinition.InferenceAccelerator = InferenceAccelerator;
TaskDefinition.Secret = Secret;
TaskDefinition.EnvironmentFile = EnvironmentFile;
TaskDefinition.VolumeFrom = VolumeFrom;
TaskDefinition.HostEntry = HostEntry;
TaskDefinition.TaskDefinitionPlacementConstraint = TaskDefinitionPlacementConstraint;
TaskDefinition.Volume = Volume;
TaskDefinition.Tmpfs = Tmpfs;
TaskDefinition.ContainerDefinition = ContainerDefinition;
TaskDefinition.KeyValuePair = KeyValuePair;
TaskDefinition.HealthCheck = HealthCheck;
TaskDefinition.LinuxParameters = LinuxParameters;
TaskDefinition.ProxyConfiguration = ProxyConfiguration;
